<script>
import {mapActions, mapGetters, mapState} from "vuex";
import DropdownNav from "../../../../components/DropdownNav";
import UserBar from "./UserBar";

export default {
   name: 'navbar',
   data: function () {
      return {
         title: 'PETER BÜDEL',
         menu: 'MENU',
         language: 'DE',
         selectedCategory: null,
         navigatedParentCategoryId: null
      }
   },
   computed: {
      ...mapGetters('account', ['canRead']),
      ...mapGetters('shopContent', ['filteredNavItems']),
      ...mapState("account", ["user", "loadingUser"]),
      ...mapState('categoryManagement', ['categories', 'customerShops']),
      ...mapState('shopContent', ['navItems']),
      customerShopList() {
         if (this.user && this.user.customerShopList) {
            return this.$_.sortBy(this.user.customerShopList.filter(shop => {
               return (shop.customerId && shop.customerId > 0);
            }), 'webName');
         }
         return [];
      },
      filteredCategories: function () {
         return this.categories.filter(category => (category.webName));
      }
   },
   mounted() {
      if (this.$route.params && this.$route.params.parentCategory) {
         this.selectedCategory = this.categories.find(category => {
            return category.id === Number(this.$route.params.parentCategory);
         });
      }
   },
   beforeRouteUpdate(to, from, next) {
      if (to.params && to.params.parentCategory) {
         this.selectedCategory = this.categories.find(category => {
            return category.id === Number(to.params.parentCategory);
         });
      }
      next();
   },
   methods: {
      ...mapActions("account", ["login", "logout"]),
      toggleCategory(category) {
         if (category && category.childrenCategoryList && category.childrenCategoryList.length > 0) {
            this.selectedCategory = category;
         } else {
            this.selectedCategory = null;
         }
      }
   },
   components: {
      "dropdown-nav": DropdownNav,
      "user-bar": UserBar
   }
}
</script>